export default {
  loading: {
    loading: false,
    text: '',
    timeout: 20000,
  },
  messages: [],
  user: null,
  profile: null,
  currentLocation: null,
  map: {
    default: true,
    center: { lat: 40.7128, lng: 74.006 },
  },
  searchText: '',
}



// WEBPACK FOOTER //
// ./src/store/reducers/initialState.js